// based on https://docs.google.com/document/d/1PszbMD2JgXitdGb3qnn7RrqXJokpWL1mOZDNbF3FNZI/edit#heading=h.br6gq6igc4wu
// later on https://flightscope.atlassian.net/browse/BBP-891

const SoftballPitchTypes = {
    Fastball: { key: 'FA', name: 'Fastball'},
    Changeup: { key: 'CH', name: 'Changeup'},
    Curveball: { key: 'CU', name: 'Curveball'},
    RiseBall: { key: 'RI', name: 'Riseball'},
    DropBall: { key: 'DR', name: 'Dropball'},
    Slider: { key: 'SL', name: 'Slider'},
    Screwball: { key: 'SC', name: 'Screwball'},
    Other: { key: 'OT', name: 'Other'},
    Unidentified: { key: 'UI', name: 'Unidentified'},
};

export default SoftballPitchTypes;